import { useEffect } from "react";

//Using setInterval directly causes flickers
//https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export default function useInterval(callback: () => void, delay: number) {
    // Set up the interval.
    useEffect(() => {
        function tick() {
            callback?.();
        }
        if (delay != null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
        // eslint-disable-next-line unicorn/no-useless-undefined -- required by typescript
        return undefined;
    }, [delay, callback]);
}

export function useTopOfMinuteInterval(callback: (() => void) | null, delay: number = 60_000) {
    // Set up the interval.
    useEffect(() => {
        // eslint-disable-next-line unicorn/no-useless-undefined -- required by typescript
        if (callback == null) return undefined;

        const msUntilTopOfMinute = (60_000 - Date.now() % 60_000);

        let intervalId: NodeJS.Timeout | null = null;
        const timeoutId = setTimeout(() => {
            callback();
            intervalId = setInterval(callback, delay);
        }, msUntilTopOfMinute);

        return () => {
            clearTimeout(timeoutId);
            if (intervalId != null) clearInterval(intervalId);
        }
    }, [callback, delay]);
}